module.exports = __webpack_public_path__ + "img/shogi_2021_pack_2_0004.29c66454.png";